import { render, staticRenderFns } from "./RecommendationColumn.vue?vue&type=template&id=1b2ab408&scoped=true&"
import script from "./RecommendationColumn.vue?vue&type=script&lang=js&"
export * from "./RecommendationColumn.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationColumn.vue?vue&type=style&index=0&id=1b2ab408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ab408",
  null
  
)

export default component.exports